import React from 'react';
import { RefreshCw, UserPlus } from 'lucide-react';
import { Button } from '../ui/Button';
import { Banner } from '../ui/Banner';
import { DjayAvatar } from '../../mascot';
interface DemoBannerProps {
  onResetDemo: () => void;
  onRegister: () => void;
}
const DjayIcon = ({
  className
}: {
  className?: string;
}) => <div className={`shrink-0 bg-white/60 rounded-full p-1 shadow-sm border border-amber-200/50 ${className}`} data-id="element-2155">
    <DjayAvatar size="xs" emotion="pointing" animate={false} data-id="element-2156" />
  </div>;
export function DemoBanner({
  onResetDemo,
  onRegister
}: DemoBannerProps) {
  return <Banner variant="warning" icon={DjayIcon} title="DEMO MODUS" className="z-50 relative rounded-none sm:rounded-none border-x-0 border-t-0" action={<div className="flex items-center gap-2 w-full sm:w-auto" data-id="element-2158">
          <Button variant="ghost" size="sm" onClick={onResetDemo} className="flex-1 sm:flex-none text-amber-800 hover:bg-amber-200/50 hover:text-amber-900" data-id="element-2159">
            <RefreshCw className="w-4 h-4 mr-1.5" data-id="element-2160" />
            Reset
          </Button>
          <Button variant="danger" size="sm" onClick={onRegister} className="flex-1 sm:flex-none shadow-sm" data-id="element-2161">
            <UserPlus className="w-4 h-4 mr-1.5" data-id="element-2162" />
            Account maken
          </Button>
        </div>} data-id="element-2157">
      <span className="opacity-90" data-id="element-2163">Je verkent de app met voorbeelddata</span>
    </Banner>;
}